var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_2174)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6419 5.31901C14.9594 5.31901 16.4414 7.65479 16.4414 7.65479C16.4414 7.65479 14.1807 8.93268 14.1807 11.708C14.1807 15.0019 17.0206 15.9601 17.0206 15.9601C17.0206 15.9601 14.7791 21.5003 12.2621 21.5003C10.8467 21.5003 10.7521 20.6522 8.87126 20.6522C7.23785 20.6522 6.68701 21.5003 5.44272 21.5003C3.06784 21.5003 0 16.0999 0 11.708C0 7.14589 3.10607 5.31901 5.05312 5.31901C6.76297 5.31901 7.47505 6.36713 8.85215 6.36713C10.0112 6.36713 10.9232 5.31901 12.6419 5.31901ZM12.2434 0.666992C12.585 2.90305 10.638 5.66856 8.31111 5.5786C7.96904 2.73341 10.4767 0.81709 12.2434 0.666992Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_2174"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.26cbfed1f77c20cd46787ea3f5536e50.svg";
export { ForwardRef as ReactComponent };